import { useState } from "react";
import {
  CaretDownIcon,
  CaretUpIcon,
  GridPresetOneHalf,
  GridRow,
  HideFor,
  OptimizelyEditProperty,
} from "/App.Components";
import { HeroInsightSectionPageProps } from "/Models/Generated/HeroInsightSectionPageProps";
import "./HeroInsightSectionPage.scss";
import HideFrom, { Breakpoint } from "/Components/Layout/HideFrom/HideFrom";
import cn from "classnames";

const HeroInsightSectionPage = ({
  heading,
  headingPropertyName,
  leadText,
  leadTextPropertyName,
  useH2InHeader,
  buttonsHeading,
  buttons,
  buttonsPropertyName,
  buttonsExpandHeading,
  buttonsCollapseHeading,
}: HeroInsightSectionPageProps) => {
  const [buttonsExpanded, setButtonsExpanded] = useState(false);
  return (
    <div className="hero-insight-section-norad">
      <GridRow>
        <GridPresetOneHalf noWrapForTablet>
          <OptimizelyEditProperty propertyName={headingPropertyName}>
            {useH2InHeader ? (
              <h2 className="hero-insight-section-norad__heading">{heading}</h2>
            ) : (
              <h1 className="hero-insight-section-norad__heading">{heading}</h1>
            )}
          </OptimizelyEditProperty>
        </GridPresetOneHalf>
        <GridPresetOneHalf noWrapForTablet>
          <OptimizelyEditProperty propertyName={leadTextPropertyName}>
            <p className="hero-insight-section-norad__lead-text">{leadText}</p>
          </OptimizelyEditProperty>
        </GridPresetOneHalf>
        <div className="hero-insight-section-norad__bottom">
          <HideFor mobile={true}>
            {buttonsHeading && (
              <p className="hero-insight-section-norad__buttons-heading">
                {buttonsHeading}
              </p>
            )}
          </HideFor>
          <HideFrom breakpoint={Breakpoint.Tablet}>
            {buttonsExpandHeading && (
              <button
                className="hero-insight-section-norad__buttons-expand-button"
                onClick={() => setButtonsExpanded((prev) => !prev)}
              >
                <span className="hero-insight-section-norad__buttons-expand-button__text">
                  {buttonsExpanded
                    ? buttonsCollapseHeading
                    : buttonsExpandHeading}
                </span>
                {buttonsExpanded ? (
                  <CaretUpIcon size="24" thickness="Reg" />
                ) : (
                  <CaretDownIcon size="24" thickness="Reg" />
                )}
              </button>
            )}
          </HideFrom>
          <OptimizelyEditProperty
            propertyName={buttonsPropertyName}
            clientRender
          >
            <div
              className={cn("hero-insight-section-norad__buttons-wrapper", {
                "hero-insight-section-norad__buttons-wrapper--is-expanded":
                  buttonsExpanded,
              })}
            >
              {buttons?.map((button, index) => (
                <a
                  key={button.link + index.toString()}
                  href={button.link?.href}
                  className="hero-insight-section-norad__button"
                >
                  {button.iconHref && (
                    <HideFor mobile={true} display="flex">
                      <img
                        className="hero-insight-section-norad__button__icon"
                        src={button.iconHref}
                        alt=""
                      />
                    </HideFor>
                  )}
                  <span className="hero-insight-section-norad__button__text">
                    {button.link?.text}
                  </span>
                </a>
              ))}
            </div>
          </OptimizelyEditProperty>
        </div>
      </GridRow>
    </div>
  );
};

export default HeroInsightSectionPage;
